var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 40,
    viewBox: "0 0 158 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 38C6.45395 34.3559 9.78917 29.873 16.3333 28.4848C27.388 26.1399 37.5573 25.7576 49.037 25.7576C58.572 25.7576 68.3274 25.2078 77.8518 24.7879C86.0094 24.4282 94.2898 23.7438 102.222 22.1212C113.994 19.7133 125.29 16.65 136.259 12.3636C143.307 9.60969 149.523 5.53296 156 2",
    stroke: "#3EAB36",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.adad347ab0bf6b70e660126f9e69762c.svg";
export { ForwardRef as ReactComponent };